<div class="build-history-dialog">
  <div class="dialog-header">
    <div>
      <h5 class="dialog-title">Deploy history</h5>
      <p class="dialog-sub">
        {{ data.versionLabel }} · branch <code>{{ data.branch }}</code>
      </p>
    </div>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="dialog-body" *ngIf="data.history?.length; else empty">
    <ul class="history-list" role="listbox" [attr.aria-label]="'Last ' + data.history.length + ' merges'">
      <li *ngFor="let entry of data.history"
          role="option"
          class="history-item"
          [class.is-selected]="selected?.sha === entry.sha"
          (click)="select(entry)">
        <span class="pr-badge">{{ prLabel(entry) }}</span>
        <span class="pr-title">{{ entry.title }}</span>
        <span class="pr-ago">{{ relativeTime(entry.date) }}</span>
      </li>
    </ul>

    <aside class="history-detail" *ngIf="selected">
      <h6 class="detail-heading">{{ prLabel(selected) }}</h6>
      <p class="detail-title">{{ selected.title }}</p>
      <dl class="detail-meta">
        <div>
          <dt>Author</dt>
          <dd>{{ selected.author }}</dd>
        </div>
        <div>
          <dt>When</dt>
          <dd>
            {{ relativeTime(selected.date) }}
            <span class="muted">({{ absoluteTime(selected.date) }})</span>
          </dd>
        </div>
        <div>
          <dt>Commit</dt>
          <dd><code>{{ selected.sha }}</code></dd>
        </div>
        <div *ngIf="selected.stats">
          <dt>Changes</dt>
          <dd>{{ selected.stats }}</dd>
        </div>
        <div *ngIf="selected.subject !== selected.title">
          <dt>Subject</dt>
          <dd class="subject">{{ selected.subject }}</dd>
        </div>
      </dl>
    </aside>
  </div>

  <ng-template #empty>
    <div class="dialog-body empty">
      <p>No deploy history embedded in this build.</p>
      <p class="muted">History is written at deploy time by <code>ops/write-frontend-build-info.sh</code>.</p>
    </div>
  </ng-template>

  <div class="dialog-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="close()">Close</button>
  </div>
</div>
